module.exports = __webpack_public_path__ + "media/plastic_3.3d24fab7.webm";